/**
 * Copyright 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { SVGIcon, theme } from "@nordcloud/gnui";

type Props = {
  onClick: (
    event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
  ) => void;
  ariaLabel?: string;
};

export function RemoveFilterIconButton({ onClick, ariaLabel }: Props) {
  return (
    <span
      role="button"
      tabIndex={0}
      onClick={onClick}
      aria-label={ariaLabel}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClick(event);
        }
      }}
      style={{
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        background: "transparent",
        border: "none",
        padding: 0,
        pointerEvents: "auto",
      }}
    >
      <SVGIcon
        name="trash"
        color={theme.color.text.text01}
        style={{ display: "block" }}
      />
    </span>
  );
}
